module.exports = __webpack_public_path__ + "img/lobster-blue.a4f892c8.svg";